import React from "react";

import "./styles.css";

import { useNavigation } from "../../../utils/functions";

function HeaderMenuButton({ path, text }) {
  const goTo = useNavigation();
  return (
    <div onClick={() => goTo(path)} className="header-menu-button">
      <div className="header-menu-button-container">
        <span className="header-menu-button-label">{text}</span>
        <span className="header-menu-button-label">{text}</span>
      </div>
    </div>
  );
}

export default HeaderMenuButton;
